import { RG_TYPE as o, DOOR_TYPE as e } from "@project-rouge/rg-core";
const i = (r) => r.type !== o.Door ? !1 : r.data.doorType === e.Single;
export {
  i as isSingleDoor
};
//# sourceMappingURL=index8.js.map
